module.exports = __webpack_public_path__ + "media/images/step-recource--e16aa088.png";